import React from "react";
import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <div style={{ maxWidth: "600px", margin: "50px auto", padding: "1rem" }}>
      <h1>Privacy Policy</h1>
      <p>
        {/* Replace below with your actual privacy policy text */}
        Your privacy is important to us. This privacy policy explains how we collect, use...
      </p>
      <p>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum at...
      </p>

      <p>
        <Link to="/">Back to Home</Link>
      </p>
    </div>
  );
}
